import {
	Button,
	ButtonLink,
	Dropdown,
	Icon,
	Select,
	Checkbox,
	InputNick,
	InputRange,
} from '@/components/ui';
import OrderPreviewsForm from '../orderPreviewsForm/OrderPreviewsForm';
import React, {
	useEffect,
	useState,
	useRef,
	useMemo,
	useCallback,
} from 'react';
import GirlCard from '../cards/girlCard/GirlCard';
import { useDispatch, useSelector } from 'react-redux';
import { show } from '@/stores/slices/showFilterSlice';
import { showShort } from '@/stores/slices/showFilterSlice';
import {
	getAllModels,
	getAllModelsMeta,
	getHasMorePage,
	getIsLoading,
	getIsMainPage,
	forwardPage,
	getPage,
} from '@/stores/slices/modelsState';
import { getTitle } from '@/stores/slices/titleSlice';
import {
	getProfilesOnMapCount,
	getSortParam,
	setSortLocation,
	setSortParam,
} from '@/stores/slices/filterSlice';

import { setStoriesMap } from '@/stores/slices/popupSlice';
import {
	getUserCurrentCity,
	getCountriesData,
	getUserCurrentDistrict,
	setLinksCurrentCity,
} from '@/stores/slices/userSlice';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useLadyService from '@/services/LadyService';
import { SelectCountry } from '../ui';
import ShortFilterData from '../shortFilter/ShortFilterData';
import './navigation.scss';
import { getSelected } from '@/stores/slices/agencyFilterSlice';
import { getCountrySlug } from '@/stores/slices/userSlice';
import { getNotDisabledCheckbox } from '@/stores/slices/modelsState';
import Pagination from '../pagination/Pagination';
import { selectAdd, selectReset } from '@/stores/slices/agencyFilterSlice';
import Notifications from '@/components/notifications/Notifications';
import StoriesSlider from '@/components/sliders/storiesSlider/StoriesSlider';
import { Popup } from '@/components/popups';
import AdvertBanner from '../ui/banner/AdvertBanner';
import { Filters } from '@/components/header/components';
import { useFilterLogicContext } from '../filter/FilterLogicProvider';
import { setOneModelPosition } from '@/stores/slices/mapModelSlice';
import { getValidDistrictSlug } from '@/helper/linkCitySlug';
import CitySlider from '../citySlider/CitySlider';

const RenderBanners = React.memo(() => (
	<>
		<AdvertBanner
			key="advert_video"
			type="video"
		/>
		<AdvertBanner
			key="advert_ero"
			type="ero"
		/>
	</>
));

const Navigation = ({
	agencyId = false,
	partyId = false,
	mainPage = false,
	checkbox = false,
	profiles_statistic = false,
	preview_price = false,
	changeParty = false,
	party = false,
	onMap,
}) => {
	/* HOOKS */
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const { lang, windowWidth, t, userType, userTypeAgency, userTypeIndi } =
		useLadyService();

	const { params, city: url_city } = useParams();

	const location = useLocation();

	const FILTER = useFilterLogicContext();

	const { options: shortfilter_options, main_title } = ShortFilterData();

	/* SELECTORS */

	const currentDistrict = useSelector(getUserCurrentDistrict);
	const countriesData = useSelector(getCountriesData);
	const selectedAdds = useSelector(getSelected);
	const models = useSelector(getAllModels);
	const currentCity = useSelector(getUserCurrentCity);
	const validCurrentDistrictSlug = getValidDistrictSlug(
		currentCity,
		currentDistrict,
		countriesData,
	);
	const morePage = useSelector(getHasMorePage);
	const meta = useSelector(getAllModelsMeta);
	const countrySlug = useSelector(getCountrySlug);
	const isMainPage = useSelector(getIsMainPage);
	const isLoading = useSelector(getIsLoading);
	const title = useSelector(getTitle);
	const profilesOnMapCount = useSelector(getProfilesOnMapCount);
	const { keysWithValueTrue } = useSelector(getNotDisabledCheckbox);
	const page = useSelector(getPage);

	/* CONSTANTS */

	const filterNavigation = useMemo(
		() => [
			{ id: 1, link: '#', title: t('bynew'), value: 'date' },
			{ id: 2, link: '#', title: t('byprice'), value: 'price' },
			{ id: 3, link: '#', title: t('bylocation'), value: 'location' },
			{ id: 4, link: '#', title: t('byrating'), value: 'rating' },
		],
		[t],
	);

	const [selectedVisualValue, setSelectedVisualValue] = useState({
		title: '',
		value: 'focus',
		icon: 'longer-view',
	});

	const visualTypeOptions = useMemo(
		() => [
			{
				id: 11,
				title: t('standartview'),
				value: 'focus',
				icon: 'small-view',
			},
			{
				id: 21,
				title: t('minview'),
				value: 'net',
				icon: 'longer-view',
			},
		],
		[t],
	);

	useEffect(() => {
		const currentVt = visualTypeOptions.find(
			(i) => i.value === selectedVisualValue.value,
		);
		setSelectedVisualValue(currentVt);
	}, [visualTypeOptions]);

	const setVisualTypeOption = () => {
		const found = visualTypeOptions.find(
			(i) => i.value !== selectedVisualValue.value,
		);
		const obj = {
			value: found.value,
			title: '',
			icon: found.icon,
		};

		localStorage.setItem('visualType', obj.value);

		setSelectedVisualValue(obj);
	};

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	const { titleParams, mobileTitleParams } = useMemo(() => {
		let postCity = t('incity', { City: currentCity.title ?? '' });
		let postTitle = t('h1main', { City: currentCity.title ?? '' });
		let postTitleMobile = t('h1main', { City: '' });

		if (countrySlug) {
			postCity = `${currentCity?.title}`;
			postTitle = t('h1country', {
				Country: currentCity.title,
				CountryCode: currentCity.code,
			});
			postTitleMobile = t('h1country', {
				Country: '',
				CountryCode: currentCity.code,
			});
		}

		if (currentDistrict?.name) {
			postTitle = t('h1district', {
				City: currentCity.title ?? '',
				District: currentDistrict?.name ?? '',
			});
		}

		if (params?.includes('massage')) {
			postTitle = t('h1massage', {
				Country: currentCity.title ?? '',
				District: currentDistrict?.name,
			});
			postTitleMobile = t('h1massage', { Country: '', District: '' });
		}

		const titleString =
			title.length <= 0 || (title.length === 1 && title[0] === 'massage')
				? undefined
				: title
					.filter((item) => !!item)
					.map((item) => {
						if (item === 'escort') {
							return t('accompaniment');
						} else {
							return t(item);
						}
					})
					.join(', ');

		const titleParams = !!titleString
			? t('h1filters', {
				Country: postCity,
				District: currentDistrict?.name ?? '',
				Filters: titleString,
			})
			: postTitle;

		const mobileTitleParams = !!titleString
			? t('h1filters', {
				District: currentDistrict?.name ?? '',
				Filters: titleString,
				Country: '',
			})
			: postTitleMobile;

		return {
			titleString,
			titleParams,
			mobileTitleParams,
		};
	}, [currentCity, countrySlug, currentDistrict, params, title, t]);

	/* STATES AND REFS*/

	// check why this is needed
	const [previewsModels, setPreviewsModels] = useState([]);

	const [prevPath, setPrevPath] = useState('/');

	const [allSelected, setALlSelected] = useState(false);

	const [currentActive, setCurrentActive] = useState('');

	const [mobileCityOpen, setMobileCityOpen] = useState(false);

	const [noadsPopup, setNoadsPopup] = useState(false);

	const scrollPosition = useRef(0);

	/* METHODS */

	const selectAll = useCallback(() => {
		const status = !allSelected;
		setALlSelected(status);
		if (status) {
			models.forEach((model) => {
				dispatch(selectAdd(model.id));
			});
		} else {
			dispatch(selectReset());
		}
	}, [allSelected, models, dispatch]);

	const handleNoAdsPopup = () => {
		localStorage.removeItem('save_gender_filter');
		setNoadsPopup(false);
		// FILTER.resetFilter(false, `/${lang}/${currentCity.slug ?? 'czechia'}`);
		console.log(
			`=> path: `,
			`/${lang}/${currentCity?.slug ? (validCurrentDistrictSlug && currentCity.slug === 'prague' ? `${currentCity.slug}_${validCurrentDistrictSlug}` : currentCity.slug) : 'czechia'}`,
			currentCity.slug,
			currentDistrict.slug,
		);
		FILTER.resetFilter(
			false,
			`/${lang}/${currentCity?.slug ? (validCurrentDistrictSlug && currentCity.slug === 'prague' ? `${currentCity.slug}_${validCurrentDistrictSlug}` : currentCity.slug) : 'czechia'}`,
		);
	};

	const handleOpenFilters = () => {
		dispatch(show());
	};

	const handleGoBack = () => {
		navigate(prevPath);
	};

	const getUserLocation = async () => {
		return new Promise((resolve, reject) => {
			if (!navigator.geolocation) {
				reject(new Error("Geolocation is not supported by this browser."));
				return;
			}

			navigator.geolocation.getCurrentPosition(
				(position) => {
					resolve({
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					});
				},
				(error) => {
					reject(error);
				},
				{
					enableHighAccuracy: true,
					timeout: 10000,
					maximumAge: 0,
				}
			);
		});
	}


	const sort_param = useSelector(getSortParam);

	const setStorting = async (item) => {
		if (sort_param !== item) {
			if (item === 'location') {
				const user_location = await getUserLocation()
				if (user_location.lat && user_location.lng) {
					dispatch(setSortLocation(user_location))
					dispatch(setSortParam(item))
				}
			} else {
				dispatch(setSortParam(item));
			}
		}
	};

	/* EFFECTS */

	// useEffect(() => {

	// }, [sort_param])

	// used for package models prevew potentialy on parties page or somewhere in agency preview logic
	useEffect(() => {
		if (models)
			setPreviewsModels(models.filter((model) => model?.ready_preview));
	}, [models]);

	// simply used to handle previous paths
	useEffect(() => {
		if (location.pathname !== prevPath) {
			setPrevPath(location.pathname);
		}
		dispatch(setLinksCurrentCity(url_city ?? 'czechia'));
	}, [location.pathname]);

	// applies goback handling
	useEffect(() => {
		window.addEventListener('popstate', handleGoBack);

		return () => {
			window.removeEventListener('popstate', handleGoBack);
		};
	}, []);

	// handle preset visual type from local storage
	useEffect(() => {
		if (windowWidth < 767.98) {
			const visualType = localStorage.getItem('visualType');

			if (visualType) {
				const found = visualTypeOptions.find(
					(i) => i.value === visualType,
				);

				setSelectedVisualValue({
					value: found.value,
					title: '',
					icon: found.icon,
				});
			}
		}
	}, [windowWidth]);

	/* LAYOUT */

	const checkboxNavTemplate = useCallback(
		(i) => {
			try {
				if (isJsdom && mainPage) {
					if (i.value === 'agency') {
						return (
							<a
								className="hover-line"
								href={`/${lang}/agencies`}
							>
								{i.title}
							</a>
						);
					}
					if (i.value === 'massagebrothel') {
						return (
							<a
								className="hover-line"
								href={`/${lang}/massagebrothels`}
							>
								{i.title}
							</a>
						);
					} else {
						const districtSlug = getValidDistrictSlug(
							currentCity?.slug,
							currentDistrict,
							countriesData,
						);
						let link = `/${lang}/${currentCity.slug
							}/${FILTER.getFilterValue(i.value)}`;
						if (districtSlug) {
							link = `/${lang}/${currentCity.slug}_${districtSlug
								}/${FILTER.getFilterValue(i.value)}`;
						}
						return i.disabled ? (
							<p className="hover-line _disabled m-0">
								{i.title}
							</p>
						) : (
							<a
								disabled={i.disabled}
								className={`hover-line ${i.disabled ? ' _disabled' : ''}`}
								href={link}
							>
								{i.title}
							</a>
						);
					}
				} else {
					return (
						<Checkbox
							linkCheckbox={i.isLink}
							key={i.id}
							name={i.name}
							id={i.id}
							value={i.value}
							title={i.title}
							checked={i.checked}
							count={i.count}
							disabled={i.disabled}
							onChange={(e) => {
								FILTER.handleInstantCheckBox(e);
							}}
						/>
					);
				}
			} catch (e) {
				console.error(e, 'in: ', i);
			}
		},
		[
			lang,
			currentCity.slug,
			currentDistrict,
			countriesData,
			FILTER.getFilterValue,
			FILTER.filterStateIndicator,
			shortfilter_options,
			isJsdom,
		],
	);

	// ◀️ Define skeletons as GirlCards with isLoading={true} inside parent component
	const skeletons = Array.from({ length: 24 }).map((_, idx) => (
		<GirlCard
			key={`skeleton-${idx}`}
			isLoading={true}
		/>
	));

	const priceRef = useRef(null);
	const ageRef = useRef(null);

	useEffect(() => {
		const age = FILTER.filterState.ranges.current_state.age;
		const price = FILTER.filterState.ranges.current_state.price;

		const shouldUpdatePrice =
			priceRef.current?.local_value?.min !== price.min ||
			priceRef.current?.local_value?.max !== price.max;

		if (priceRef.current?.setValues && shouldUpdatePrice) {
			// console.log(`=> set to price: `, price);

			priceRef.current.setValues(price.min, price.max);
		}

		const shouldUpdateAge =
			ageRef.current?.local_value?.min !== age.min ||
			ageRef.current?.local_value?.max !== age.max;

		if (ageRef.current?.setValues && shouldUpdateAge) {
			// console.log(`=> set to age: `, age);
			ageRef.current.setValues(age.min, age.max);
		}
	}, [FILTER.filterStateIndicator]);

	// const alternatePath = useMemo(() => {
	// 	const paths = {
	// 		canonical: 'https://lady4love.com',
	// 		ru: 'https://lady4love.com/ru/czechia',
	// 		cz: 'https://lady4love.com/cz/czechia',
	// 	};

	// 	if (params) {
	// 		paths.canonical = paths.canonical + location.pathname;
	// 		paths.ru = paths.canonical.replace('/en/', '/ru/');
	// 		paths.cz = paths.canonical.replace('/en/', '/cz/');
	// 	}

	// 	return paths;
	// }, [location]);

	// useEffect(() => {
	// 	const existingLinks = document.querySelectorAll(
	// 		'link[rel="alternate"]',
	// 	);
	// 	existingLinks.forEach((link) => link.remove());

	// 	const linksData = [
	// 		{ hreflang: 'en', href: alternatePath.canonical },
	// 		{ hreflang: 'ru', href: alternatePath.ru },
	// 		{ hreflang: 'cs', href: alternatePath.cz },
	// 		{ hreflang: 'x-default', href: alternatePath.canonical },
	// 	];

	// 	linksData.forEach(({ hreflang, href }) => {
	// 		const link = document.createElement('link');
	// 		link.rel = 'alternate';
	// 		link.hreflang = hreflang;
	// 		link.href = href;
	// 		document.head.appendChild(link);
	// 	});
	// }, [alternatePath]);

	// trigger a popup if feed is empty and gender only applied with city filter
	useEffect(() => {
		if (
			FILTER.isDataEmpty &&
			!FILTER.isOtherFilterActive &&
			params &&
			url_city &&
			url_city !== 'czechia'
		) {
			setNoadsPopup(true);
		}
	}, [FILTER.isDataEmpty]);

	// tryout pending cards directly

	const PAGE_SIZE = 24;

	const pendingCount = useMemo(() => {
		return isJsdom
			? 0
			: FILTER.showSkeletons || FILTER.showMore
				? PAGE_SIZE
				: 0;
	}, [FILTER.showMore, FILTER.showSkeletons]);

	const cardSlots = useMemo(() => {
		const real = (models ?? []).filter((m) => m?.id);

		// SSR/jsdom: only ever emit what we actually have. Never placeholders.
		if (isJsdom) {
			return real.map((data, idx) => ({
				key: `model-${data.id}`,
				idx,
				data,
			}));
		}

		// on a fresh load (not load-more) old models must not be shown
		const base = FILTER.showSkeletons ? [] : real;

		const slots = base.map((data, idx) => ({
			key: `model-${data.id}`,
			idx,
			data,
		}));

		for (let i = 0; i < pendingCount; i++) {
			// stable key tied to the page being loaded, NOT to the array length
			slots.push({
				key: `skeleton-${page}-${i}`,
				idx: slots.length,
				data: null,
			});
		}

		return slots;
	}, [models, pendingCount, FILTER.showSkeletons, page]);

	return (
		<section
			id={'models'}
			className={
				!isMainPage && (agencyId || partyId)
					? 'agency-filter __container'
					: isJsdom
						? 'navigation__container ssr'
						: 'navigation__container'
			}
		>
			{!isMainPage && (agencyId || partyId) ? (
				<>
					<div className="agency-filter__top mb-24">
						{profiles_statistic?.total && (
							<h3 className={'mb-0'}>
								{profiles_statistic?.total} {t('agencymodels')}
							</h3>
						)}

						{checkbox &&
							previewsModels.length > 0 &&
							!(userTypeAgency || userTypeIndi) ? (
							<a
								href={'#orderToLook'}
								className={'hover-line color-green'}
							>
								{t('odrderseveral')}
							</a>
						) : null}

						{changeParty && (
							<>
								<h2 className={'mb-0'}>
									{t('showparticipants')}
								</h2>
								<Checkbox
									id={'agencyFilterAll'}
									name={'all'}
									clazzLabel={'p-0'}
									checked={allSelected}
									onChange={selectAll}
									title={`${t('selectall')}`}
								/>
							</>
						)}
					</div>
				</>
			) : (
				!party && (
					<>
						<div className={'navigation__top'}>
							{isJsdom || windowWidth > 767.98 ? (
								<>
									<h1>
										{!FILTER.isFilterEmpty
											? params?.split('-').length
												? titleParams
												: t('matching')
											: titleParams}
									</h1>

									<InputNick
										type="search"
										placeholder={t('modelname')}
										id="headerSearch"
										clazz={'search__input'}
										name={'nickname'}
									/>

									{windowWidth > 767.98 && !isJsdom && (
										<ButtonLink
											onClick={() => {
												profilesOnMapCount &&
													dispatch(
														setStoriesMap(true),
													);
												dispatch(
													setOneModelPosition(false),
												);
											}}
											clazz={`button button-s on-map button--green__secondary`}
											size={'s'}
											disabled={!profilesOnMapCount}
											title={t('h2country')}
										>
											{t('onmap')}
											<Icon
												size={'m'}
												spritePath={'map'}
											/>
										</ButtonLink>
									)}

									{isJsdom &&
										keysWithValueTrue?.includes(
											'statusMassage',
										) && (
											<ButtonLink
												clazz={`button_outline--black`}
												href={`/${lang}/${currentCity.slug}/massage`}
												size={'s'}
											>
												{t('eromassage')}
											</ButtonLink>
										)}

									<Notifications />
								</>
							) : (
								<>
									<h1>
										{!FILTER.isFilterEmpty
											? params
												? mobileTitleParams + ' '
												: t('matching')
											: mobileTitleParams}{' '}
										{
											<>
												<span
													className="select-city--word"
													onClick={() =>
														setMobileCityOpen(
															(prev) => !prev,
														)
													}
												>
													{(currentCity?.title ??
														'Czechia') +
														(currentDistrict?.name
															? ` ${currentDistrict.name}`
															: '')}
												</span>
											</>
										}
									</h1>

									<SelectCountry
										data={countriesData}
										name={'city-create'}
										clazz={'select-city'}
										withoutArrow
										type={'flag'}
										defaultTitle={currentCity.title}
										currentActiveIndex={currentActive}
										isMain={true}
										activeCountry={currentCity.icon}
										setActive={setCurrentActive}
										open={mobileCityOpen}
										withoutTitle={true}
										selectDistrict={true}
									/>

									{windowWidth > 767.98 &&
										<div className="d-flex fd-row justify-center w-100 place-flilters">
											{windowWidth > 767.98 && <Filters />}

											{windowWidth > 1000.98 && (
												<div
													className={
														'navigation__top-wrapper'
													}
												>
													<ButtonLink
														anchor={true}
														onClick={() => {
															profilesOnMapCount &&
																dispatch(
																	setStoriesMap(
																		true,
																	),
																);
														}}
														square={true}
														href={'#models-map'}
														clazz={`button_outline--black`}
														size={'s'}
														disabled={
															!profilesOnMapCount
														}
													>
														<Icon spritePath={'map'} />
													</ButtonLink>
													<Notifications />
												</div>
											)}</div>}


									{windowWidth < 1000.98 && <Notifications />}

								</>
							)}
						</div>
					</>
				)
			)}

			<CitySlider />

			<div className="navigation__bottom">
				{party && (
					<h3 className="w-100">
						{t('participatingmodels')} {profiles_statistic ?? 0}
					</h3>
				)}
				<nav
					className={
						isJsdom ? `navigation__nav ssr` : `navigation__nav`
					}
				>
					{!isJsdom && windowWidth > 767.98 && (
						<>
							<Dropdown
								title={t('price')}
								name={'price'}
								clazzWrapper={'header__filter--price'}
								size={'s'}
								count={FILTER.isPriceSelected}
								disabled={
									FILTER.filterState.ranges.default_state
										.price.min ===
									FILTER.filterState.ranges.default_state
										.price.max
								}
							>
								<InputRange
									ref={priceRef}
									min={
										FILTER.filterState.ranges.default_state
											.price.min
									}
									max={
										FILTER.filterState.ranges.default_state
											.price.max
									}
									step={10}
									clazz={'range--price'}
									inputIdLeft={'minPriceFilter'}
									inputIdRight={'maxPriceFilter'}
									title={`${t('price')},`}
									name={'price'}
									subtitle={`${lang === 'cz' ? ' Kč' : ' €'}/${t(
										'hour',
									)}`}
									price={lang === 'cz' ? 'czk' : ''}
									warning={true}
									onChange={(values) => {
										FILTER.handleRangeChange(
											'price',
											values,
										);
									}}
									value={
										FILTER.filterState.ranges.current_state
											.price
									}
								/>
							</Dropdown>
							<Dropdown
								title={t('age')}
								name={'age'}
								size={'s'}
								clazzWrapper={'header__filter--age'}
								count={FILTER.isAgeSelected}
								disabled={
									FILTER.filterState.ranges.default_state.age
										.min ===
									FILTER.filterState.ranges.default_state.age
										.max
								}
							>
								<InputRange
									ref={ageRef}
									min={
										FILTER.filterState.ranges.default_state
											.age.min
									}
									max={
										FILTER.filterState.ranges.default_state
											.age.max
									}
									step={1}
									clazz={'range--age'}
									inputIdLeft={'minAgeFilter'}
									inputIdRight={'maxAgeFilter'}
									title={`${t('age')},`}
									name={'age'}
									subtitle={` ${t('years')}`}
									warning={true}
									value={
										FILTER.filterState.ranges.current_state
											.age
									}
									onChange={(values) =>
										FILTER.handleRangeChange('age', values)
									}
								/>
							</Dropdown>
						</>
					)}

					{windowWidth < 767.98 && !isJsdom ? (
						<>
							<Button
								clazz={
									'button--secondary navigation__mobile-filter button-square'
								}
								size={'xs'}
								onClick={() => dispatch(showShort())}
							>
								<Icon
									size={'m'}
									spritePath={'filter2'}
								/>
								{t('catalogue')}{' '}
								<Icon
									size={'s'}
									spritePath={'chevrone-down'}
								/>
							</Button>
						</>
					) : null}

					{!isJsdom && (
						<div className="reset_wrapper">
							{!FILTER.isFilterEmpty &&
								FILTER.isGenderAndServiceTypeOnly && (
									<Button
										onClick={() => {
											const path =
												!location.pathname.includes(
													'/agency/',
												)
													? lang === 'en' &&
														url_city === 'czechia'
														? '/'
														: `/${lang}${url_city ? `/${url_city}` : '/czechia'}`
													: false;

											FILTER.resetFilter(false, path);
										}}
										size={'s'}
										title={t('reset')}
										clazz="header__reset hover"
									>
										{t('reset')}
									</Button>
								)}
						</div>
					)}

					{shortfilter_options.map((i) => checkboxNavTemplate(i))}

					{!isJsdom ? (
						<Dropdown
							title={main_title}
							size={'xs'}
							hideOnClick={true}
							clazzWrapper={'navigation__more '}
							clazz={'more-button'}
						>
							{shortfilter_options.map((i) =>
								checkboxNavTemplate(i),
							)}
							{
								<Button
									clazz={'button--s button--green'}
									size={'xs'}
									onClick={() => {
										dispatch(show());
									}}
								>
									{t('allfilters')}
								</Button>
							}
						</Dropdown>
					) : null}
				</nav>

				{!isJsdom && (
					<>
						<Select
							clazzWrapper="ml-auto"
							options={filterNavigation}
							withIcon={true}
							mainIcon={'sort'}
							clazzSvg={'icon-s'}
							clazz={
								'button--secondary filter-navigation no-outline '
							}
							arrowSize={'s'}
							size={'xs'}
							sorted={true}
							name={'sort'}
							controlledValue={sort_param}
							onChange={setStorting}
						/>
					</>
				)}

				{!isJsdom && windowWidth < 767.98 && (
					<Button
						clazz={'visuals-select button-icon'}
						onClick={setVisualTypeOption}
					>
						<Icon
							size={'m'}
							spritePath={selectedVisualValue.icon}
							clazz={`select__icon`}
						/>
					</Button>
				)}
			</div>

			<div
				className={`grid-cards ${selectedVisualValue.value === 'net' && windowWidth < 767.98 ? 'net_view' : ''}`}
			>
				{/* {!FILTER.isDataEmpty &&
					models?.length > 0 &&
					models.map((data, idx) => {
						if (data?.id)
							return (
								<GirlCard
									lcpCandidate={idx === 0}
									topModelsSlider={
										selectedVisualValue.value === 'net' &&
										windowWidth < 767.98
									}
									props={{ ...data, page: page }}
									size={'m'}
									key={data.id}
									selected={
										data?.ready_preview &&
										data?.ready_preview === 1
											? selectedAdds.includes(data.id)
											: false
									}
									checkbox={
										!!(
											data?.ready_preview &&
											data.ready_preview === 1
										) &&
										!mainPage &&
										checkbox
									}
									outline={data?.is_individual}
								/>
							);
					})} */}

				{cardSlots.map(({ key, idx, data }) => (
					<GirlCard
						key={key}
						isLoading={!data}
						lcpCandidate={idx === 0}
						topModelsSlider={
							selectedVisualValue.value === 'net' &&
							windowWidth < 767.98
						}
						props={data ? { ...data, page } : undefined}
						size={'m'}
						selected={
							data?.ready_preview === 1
								? selectedAdds.includes(data.id)
								: false
						}
						checkbox={
							!!(data?.ready_preview === 1) &&
							!mainPage &&
							checkbox
						}
						outline={data?.is_individual}
					/>
				))}

				{!FILTER.isDataEmpty &&
					models?.length > 0 &&
					FILTER.isFilterEmpty &&
					!location.pathname.includes('/agency/') && (
						<RenderBanners />
					)}

				{!isLoading && (isMainPage || mainPage) ? (
					<StoriesSlider size={'s'} />
				) : (
					<></>
				)}
				{FILTER.isDataEmpty && (
					<h2 className="navigation__empty">{t('notfound')}</h2>
				)}

				{/* {(FILTER.showSkeletons || FILTER.showMore) && !isJsdom && (
					<>{skeletons}</>
				)} */}
			</div>

			{morePage && !isJsdom && (
				<Button
					type="button"
					onClick={(e) => {
						e.target.blur();
						dispatch(forwardPage());
						FILTER.setShowMore(true);
						scrollPosition.current = window.scrollY;
					}}
					clazz={'navigation__show-more button--green'}
					size={'l'}
				>
					{t('showmore')}
				</Button>
			)}

			{isJsdom && meta && (
				<Pagination
					pages={meta.total_pages}
					activePage={meta.current_page}
				/>
			)}

			{(userType === 'default' || userType === 'customer') &&
				agencyId &&
				checkbox &&
				previewsModels.length > 0 ? (
				<OrderPreviewsForm
					agencyId={agencyId}
					checkbox={checkbox}
					preview_price={preview_price}
				/>
			) : (
				<></>
			)}

			{
				<Popup
					open={noadsPopup}
					onSubmit={() => handleNoAdsPopup()}
				>
					<>
						<h2>{t('nomassage')}</h2>
						<Button
							buttonType={'submit'}
							square={false}
							clazz="button--green mt-40"
						>
							{t('showsexads')}
						</Button>
					</>
				</Popup>
			}

			{/* {
				<Popup
					userClose={false}
					open={isEmptyByGender}
				>
					<>
						<h2>{t('noAdsInCity')}</h2>
						<div className="d-flex gap-16 align-center mt-40">
							<Button
								onClick={() => {
									setIsEmptyByGender(false);
									console.log(`=> remove genderSave`);
									localStorage.removeItem(
										'save_gender_filter',
									);
									FILTER.resetFilter(
										false,
										`/${lang}/${currentCity.slug ?? 'czechia'}`,
									);
								}}
								square={false}
								clazz="button--green  w-100"
							>
								{t('showAllAds')}
							</Button>
							<Button
								onClick={() => {
									setIsEmptyByGender(false);
									FILTER.resetFilter(
										false,
										`/${lang}/czechia/${params}`,
									);
								}}
								square={false}
								clazz="button--secondary  w-100"
							>
								{t('showCountryAds')}
							</Button>
						</div>
					</>
				</Popup>
			} */}
		</section>
	);
};

export default Navigation;
